import { useViewContext } from "@folksam/ui/providers/ViewContext";

import { Heading, Paragraph } from "../../../atoms";
import { Box, Flex } from "../../../cores";
import { IconEuroNCAP } from "../../../icons";

interface IEuroNCapDescription {
  descriptionTitle: string;
  descriptionText: Array<string>;
}

const EuroNCapDescription = ({
  descriptionTitle,
  descriptionText,
}: IEuroNCapDescription) => {
  const { isMobile } = useViewContext();

  return (
    <Box
      sx={{
        width: ["100%", null, null, "50%", "50%"],
        "> div": {
          marginY: 10,
          "> *:first-of-type": {
            minWidth: [70, null, null, null, 90],
            fontSize: ["xs", null, "16px", null, null],
          },
          "> p": {
            marginLeft: "sm",
            fontSize: ["xs", null, "16px", null, null],
          },
        },
      }}
    >
      <Heading as={"h4"} variant={!isMobile ? "h5" : "h6"}>
        {descriptionTitle}
      </Heading>
      <Flex>
        <IconEuroNCAP value={"|Pre 2009"} />
        <Paragraph>{descriptionText[0]}</Paragraph>
      </Flex>
      <Flex>
        <IconEuroNCAP value={"|2009"} />
        <Paragraph>{descriptionText[1]}</Paragraph>
      </Flex>
      <Flex>
        <IconEuroNCAP value={"|Efter 2012"} />
        <Paragraph>{descriptionText[2]}</Paragraph>
      </Flex>
    </Box>
  );
};

export default EuroNCapDescription;
